<template>
  <div id="myDiv">
    <div v-if="user === 'betagrodemo' || admin =='betagrodemo'">
      <!-- <div class=""></div> -->
      <!-- <br /> -->
      <vs-row>
        <ActiveS />
      </vs-row>

      <div>
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card style="border-radius: 20px">
              <vs-table hoverFlat="false" max-items="5" pagination :data="tag">
                <template slot="header">
                  <vs-list-header
                    title="Overview Temperature Sensor"
                    style="font-size: 18px"
                    color="primary"
                  ></vs-list-header>
                </template>
                <template slot="thead">
                  <vs-th
                    style="background: #484848; color: #ffffff"
                    v-for="i in headerTableTS"
                    :key="i"
                  >
                    {{ i }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    style="background: #212121; color: #ffffff"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                    <vs-td :data="data[indextr].name">
                      <vs-button
                        id="noWrap"
                        @click="viewSensor2(tr)"
                        icon="signal_cellular_alt"
                        type="flat"
                        >{{ data[indextr].name }}</vs-button
                      >
                    </vs-td>

                    <vs-td :data="data[indextr].mac">
                      {{ data[indextr].mac }}
                    </vs-td>

                    <vs-td :data="data[indextr].type">
                      {{ data[indextr].type }}
                    </vs-td>
                    <vs-td :data="data[indextr].timest">
                      {{ data[indextr].timest }}
                    </vs-td>
                    <vs-td :data="data[indextr].temp">
                      {{ data[indextr].temp }}
                    </vs-td>
                    <vs-td :data="data[indextr].humid">
                      {{ data[indextr].humid }}
                    </vs-td>
                    <vs-td :data="data[indextr].lastdate">
                      {{ data[indextr].bat }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </vs-col>
        </vs-row>
        <!-- /////-----------------------------------------------------------------------------------------------///// -->

        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card style="border-radius: 20px">
              <vs-table
                hoverFlat="false"
                max-items="5"
                pagination
                :data="asset"
              >
                <template slot="header">
                  <vs-list-header
                    title="Overview Door Sensor"
                    style="font-size: 18px"
                    color="primary"
                  ></vs-list-header>
                </template>
                <template slot="thead">
                  <vs-th
                    style="background: #484848; color: #ffffff"
                    v-for="i in headerTableDS"
                    :key="i"
                  >
                    {{ i }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    style="background: #212121; color: #ffffff"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                    <vs-td :data="data[indextr].name">
                      <vs-button
                        id="noWrap"
                        @click="viewSensor2(tr)"
                        icon="signal_cellular_alt"
                        type="flat"
                        >{{ data[indextr].name }}</vs-button
                      >
                    </vs-td>

                    <vs-td :data="data[indextr].mac">
                      {{ data[indextr].mac }}
                    </vs-td>

                    <vs-td :data="data[indextr].type">
                      {{ data[indextr].type }}
                    </vs-td>
                    <vs-td :data="data[indextr].timest">
                      {{ data[indextr].timest }}
                    </vs-td>
                    <vs-td :data="data[indextr].temp">
                      {{ data[indextr].uninstall }}
                    </vs-td>
                    <vs-td :data="data[indextr].humid">
                      {{ data[indextr].unlock }}
                    </vs-td>
                    <vs-td :data="data[indextr].lastdate">
                      {{ data[indextr].bat }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </vs-col>
        </vs-row>
        <!-- <vs-row>
      <ShowNetwork />
    </vs-row> -->
      </div>
    </div>
    <!-- ////////////////////////////////////////////////////////////////////////////////////////// -->

    <div v-if="user === 'Rivacold01' || admin === 'Rivacold01' ||user === 'dhanarak-admin'|| user === 'dhanarak-user'|| admin === 'dnet'">
      <!-- <div class=""></div> -->
      <!-- <br /> -->
      <vs-row>
        <ActiveSR />
      </vs-row>

      <div>
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card style="border-radius: 20px">
              <vs-table hoverFlat="false" max-items="5" pagination :data="tag">
                <template slot="header">
                  <vs-list-header
                    title="Overview Sensor"
                    style="font-size: 18px"
                    color="primary"
                  ></vs-list-header>
                </template>
                <template slot="thead">
                  <vs-th v-for="i in headerTableTS" :key="i">
                    {{ i }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                    <vs-td :data="data[indextr].name">
                      <vs-button
                        id="noWrap"
                        @click="viewSensor2(tr)"
                        icon="signal_cellular_alt"
                        type="flat"
                        >{{ data[indextr].name }}</vs-button
                      >
                    </vs-td>

                    <vs-td :data="data[indextr].mac">
                      {{ data[indextr].mac }}
                    </vs-td>

                    <vs-td :data="data[indextr].type">
                      {{ data[indextr].type }}
                    </vs-td>
                    <vs-td :data="data[indextr].timest">
                      {{ data[indextr].timest }}
                    </vs-td>
                    <vs-td :data="data[indextr].temp">
                      {{ data[indextr].temp }}
                    </vs-td>
                    <vs-td :data="data[indextr].humid">
                      {{ data[indextr].humid }}
                    </vs-td>
                    <vs-td :data="data[indextr].lastdate">
                      {{ data[indextr].bat }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
        </vs-row>
        <!-- <vs-row>
      <ShowNetwork />
    </vs-row> -->
      </div>
    </div>

    <!-- /////////////////////////////////////////////////////////////////////// -->

    <div v-if="user === 'unicorndemo'">
      <!-- <div class=""></div> -->
      <!-- <br /> -->
      <vs-row>
        <ActiveUni />
      </vs-row>

      <div>
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card style="border-radius: 20px">
              <vs-table
                hoverFlat="false"
                max-items="5"
                pagination
                :data="dataTprUnia"
              >
                <template slot="header">
                  <vs-list-header
                    title="Stock List"
                    style="font-size: 18px"
                    color="primary"
                  ></vs-list-header>
                </template>
                <template slot="thead">
                  <vs-th v-for="i in headerTableUN" :key="i">
                    {{ i }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                    <vs-td :data="data[indextr].name">
                      <vs-button id="noWrap" icon="local_offer" type="flat">{{
                        data[indextr].name
                      }}</vs-button>
                    </vs-td>
                    <vs-td :data="data[indextr].mac">
                      {{ data[indextr].mac }}
                    </vs-td>
                    <vs-td :data="data[indextr].detail">
                      {{ data[indextr].detail }}
                    </vs-td>

                    <vs-td :data="data[indextr].quan">
                      {{ data[indextr].quan }}
                    </vs-td>
                    <vs-td :data="data[indextr].status">
                      {{ data[indextr].status }}
                    </vs-td>
                    <vs-td :data="data[indextr].checkin">
                      {{ data[indextr].checkin }}
                    </vs-td>
                    <vs-td :data="data[indextr].checkout">
                      {{ data[indextr].checkout }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
        </vs-row>
        <!-- <vs-row>
      <ShowNetwork />
    </vs-row> -->
      </div>
    </div>

    <!-- /////////////////////////////////////////////////////////////////////// -->

    <div v-if="user === 'KPcooldemo'">
      <!-- <div class=""></div> -->
      <!-- <br /> -->
      <vs-row>
        <ActiveSR />
      </vs-row>

      <div>
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card style="border-radius: 20px">
              <vs-table hoverFlat="false" max-items="5" pagination :data="tag">
                <template slot="header">
                  <vs-list-header
                    title="Overview Sensor"
                    style="font-size: 18px"
                    color="primary"
                  ></vs-list-header>
                </template>
                <template slot="thead">
                  <vs-th v-for="i in headerTableTS" :key="i">
                    {{ i }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                    <vs-td :data="data[indextr].name">
                      <vs-button
                        id="noWrap"
                        @click="viewSensor2(tr)"
                        icon="signal_cellular_alt"
                        type="flat"
                        >{{ data[indextr].name }}</vs-button
                      >
                    </vs-td>

                    <vs-td :data="data[indextr].mac">
                      {{ data[indextr].mac }}
                    </vs-td>

                    <vs-td :data="data[indextr].type">
                      {{ data[indextr].type }}
                    </vs-td>
                    <vs-td :data="data[indextr].timest">
                      {{ data[indextr].timest }}
                    </vs-td>
                    <vs-td :data="data[indextr].temp">
                      {{ data[indextr].temp }}
                    </vs-td>
                    <vs-td :data="data[indextr].humid">
                      {{ data[indextr].humid }}
                    </vs-td>
                    <vs-td :data="data[indextr].lastdate">
                      {{ data[indextr].bat }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="12"
        >
        </vs-row>
        <!-- <vs-row>
      <ShowNetwork />
    </vs-row> -->
      </div>
    </div>

    <!-- /////////////////////////////////////////////////////////////////////// -->
    <div v-if="user === 'pttdemo' ">
      <!-- <div class=""></div> -->
      <!-- <br /> -->

      <vs-row>
        <ActiveSS />
      </vs-row>

      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card style="border-radius: 20px">
            <vs-table
              hoverFlat="false"
              max-items="5"
              pagination
              stripe
              :data="ptta"
            >
              <template slot="header">
                <vs-list-header
                  title="Daily Manpower Status"
                  style="font-size: 18px"
                  color="dark"
                ></vs-list-header>
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Mac Address </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Today Status </vs-th>
                <vs-th> First Check-in </vs-th>
                <vs-th> Last Check-out </vs-th>
                <vs-th> Daily Cumulative Working Time </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].mac">
                    {{ data[indextr].mac }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    <!-- <vs-icon icon="fiber_manual_record" :color="state"> </vs-icon> -->
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td :data="data[indextr].firstdate">
                    {{ data[indextr].firstdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].lastdate">
                    {{ data[indextr].lastdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].working">
                    {{ data[indextr].working }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
      <!-- /////-----------------------------------------------------------------------------------------------///// -->

      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card style="border-radius: 20px">
            <vs-table
              hoverFlat="false"
              max-items="5"
              pagination
              stripe
              :data="pttb"
            >
              <template slot="header">
                <vs-list-header
                  title="Daily Asset Status"
                  style="font-size: 18px"
                  color="dark"
                ></vs-list-header>
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Mac Address </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Today Status </vs-th>
                <vs-th> Installation Date </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].mac">
                    {{ data[indextr].mac }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td :data="data[indextr].firstdate">
                    {{ data[indextr].firstdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].working">
                    {{ data[indextr].working }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
    <!-- ///////////////////////////////////////////////////////////////// -->

    <!-- /////////////////////////////////////////////////////////////////////// -->
    <div v-if="user === 'syntecdemo' || user === 'swiftdemo' || user === 'SCGdemo' || user === 'TAdemo' ||user === 'Ramademo'||user === 'LTCdemo'|| user === 'Xtpledemo'">
      <!-- <div class=""></div> -->
      <!-- <br /> -->

      <vs-row>
        <ActiveST />
      </vs-row>
      <vs-row>
        <vs-col>
          <ChartTotalManHourWorker/>
        </vs-col>
      </vs-row>
      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card style="border-radius: 20px">
            <vs-table
              hoverFlat="false"
              max-items="5"
              pagination
              stripe
              :data="ptta"
            >
              <template slot="header">
                <vs-list-header
                  title="Daily Manpower Status"
                  style="font-size: 18px"
                  color="dark"
                ></vs-list-header>
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Mac Address </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Today Status </vs-th>
                <vs-th> First Check-in </vs-th>
                <vs-th> Last Check-out </vs-th>
                <vs-th> Daily Cumulative Working Time </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].mac">
                    {{ data[indextr].mac }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    <!-- <vs-icon icon="fiber_manual_record" :color="state"> </vs-icon> -->
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td :data="data[indextr].firstdate">
                    {{ data[indextr].firstdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].lastdate">
                    {{ data[indextr].lastdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].working">
                    {{ data[indextr].working }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
      <!-- /////-----------------------------------------------------------------------------------------------///// -->
    </div>
    <!-- ///////////////////////////////////////////////////////////////// -->

    <div v-if="user === 'camilliandemo'">
      <vs-row>
        <ActiveSB />
      </vs-row>

      <!-- /////-----------------------------------------------------------------------------------------------///// -->

      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card style="border-radius: 20px">
            <vs-table
              hoverFlat="false"
              max-items="5"
              pagination
              stripe
              :data="assetc"
            >
              <template slot="header">
                <vs-list-header
                  title="Overview Asset"
                  style="font-size: 18px"
                  color="dark"
                ></vs-list-header>
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Mac Address </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Status </vs-th>
                <vs-th> First Date </vs-th>
                <vs-th> Last Date </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                  <vs-td :data="data[indextr].name">
                    <vs-button
                      id="noWrap"
                      @click="viewSensor(tr)"
                      icon="signal_cellular_alt"
                      type="flat"
                      >{{ data[indextr].name }}</vs-button
                    >
                  </vs-td>

                  <vs-td :data="data[indextr].mac">
                    {{ data[indextr].mac }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td :data="data[indextr].firstdate">
                    {{ data[indextr].firstdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].lastdate">
                    {{ data[indextr].lastdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].working">
                    {{ data[indextr].working }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
      <!-- <vs-row>
      <ShowNetwork />
    </vs-row> -->
    </div>

    <!-- /////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div v-if="user === 'spartan'">
      <vs-row>
        <ActiveSP />
      </vs-row>

      <!-- /////-----------------------------------------------------------------------------------------------///// -->

      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card style="border-radius: 20px">
            <vs-table
              hoverFlat="false"
              max-items="5"
              pagination
              stripe
              :data="assetc"
            >
              <template slot="header">
                <vs-list-header
                  title="Overview Asset"
                  style="font-size: 18px"
                  color="dark"
                ></vs-list-header>
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Mac Address </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Status </vs-th>
                <vs-th> First Date </vs-th>
                <vs-th> Last Date </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <!-- :state="data[indextr].status == true ?'success':data[indextr].status == false?'danger':null" -->
                  <vs-td :data="data[indextr].name">
                    <vs-button
                      id="noWrap"
                      @click="viewSensor(tr)"
                      icon="signal_cellular_alt"
                      type="flat"
                      >{{ data[indextr].name }}</vs-button
                    >
                  </vs-td>

                  <vs-td :data="data[indextr].mac">
                    {{ data[indextr].mac }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td :data="data[indextr].firstdate">
                    {{ data[indextr].firstdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].lastdate">
                    {{ data[indextr].lastdate }}
                  </vs-td>
                  <vs-td :data="data[indextr].working">
                    {{ data[indextr].working }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
      <!-- <vs-row>
      <ShowNetwork />
    </vs-row> -->
    </div>
  </div>
</template>

<script>
import Notification from "../../dashboard/Overview/Notification";
import ShowNetwork from "../../dashboard/Overview/ShowNetwork";
// import LastSensorState from "../../dashboard/Overview/LastSensorState";
import ActiveState from "../../dashboard/Overview/ActiveState";
import ActiveS from "../../dashboard/Overview/ActiveStateindoor.vue";
import ActiveSB from "../../dashboard/Overview/CamillianCom/ActiveStateindoor.vue";
import ActiveSP from "../../dashboard/Overview/SpartanCom/ActiveStateindoor.vue";
import ActiveSR from "../../dashboard/Overview/Rivacold/ActiveStateindoor.vue";
import ActiveST from "../../dashboard/Overview/Syntec/ActiveStateindoor.vue";

import ActiveUni from "../../dashboard/Overview/Unicorn/ActiveStateindoor.vue";

import ActiveSS from "../../dashboard/Overview/PTTCom/ActiveStateindoor.vue";
import moment from "moment";
import ChartTotalManHourWorker from '../../dashboard/syntec/components/ChartTotalManHourWorker.vue';
export default {
  name: "Overview",
  components: {
    ShowNetwork,
    Notification,
    // LastSensorState,
    ActiveState,
    ActiveS,
    ActiveSB,
    ActiveSP,
    ActiveSS,
    ActiveSR,
    ActiveST,
    ActiveUni,
    ChartTotalManHourWorker,
  },
  data: () => ({
    headerTableTS: [
      "Name",
      "Mac Address",
      "Type",
      "Timestamp",
      "Temperature",
      "Humidity",
      "Battery",
    ],
    headerTableUN: [
      "Product Name",
      "Mac Address",
      "Detail",
      "Quantity",
      "Status",
      "Check-in Time",
      "Check-out Time",
    ],
    headerTableDS: [
      "Name",
      "Mac Address",
      "Type",
      "Timestamp",
      "Install Status",
      "Door Status",
      "Battery",
    ],
    sensorlist: [],
    primeTable: "",
    gateway: [],
    tag: [],
    asset: [],
    assetc: [],
    dataTpr: [],
    dataTprPtta: [],
    dataTprUnia: [],
    dataTprPttb: [],
    dataTpr2: [],
    datatestS1: [],
    datatestS4: [],
    dataApr: [],
    realData: [],
    actual: 0,
    data1: [],
    data2: [],
    state: "grey",
    ssf: 0,
    user: "",
    ptta: "",
    unia: "",
    pttb: "",
    admin: "",
    stout: "",
    details: "",
    quant: "",
  }),
  methods: {
    getTag() {
      setTimeout(() => {
        // this.tag=this.dataTpr;
      }, 300);
      this.$API.get("indoorgateway/AC233FC0BA7A").then((result1) => {
        //  console.log(result1.data[0].sensorfound);
        for (var i = 0; i <= result1.data[0].sensorfound.length; i++) {
          let obj = result1.data[0].sensorfound[i];
          // console.log(obj.mac);
          this.$API.get("indoorsensor/" + obj.mac).then((result2) => {
            // console.log(result2.data);
            if (result2.data[0].subtype === "S1") {
              //  console.log("true S1");
              let payload = {
                name: result2.data[0].name,
                mac: result2.data[0].mac,
                type: result2.data[0].subtype,
                timest: result2.data[0].lastdate,
                temp: result2.data[0].sensordata.temperature,
                humid: result2.data[0].sensordata.humidity,
                bat: result2.data[0].sensordata.battery,
              };
              //  this.dataTpr.push(payload);
              payload = {};
              //  console.log("Data",this.dataTpr);
            }
            //          else{
            // //             this.state=false;
            //            }
            //           console.log(this.state);
            //  let payload = {name:result2.data[0].name,mac:result2.data[0].mac,type:result2.data[0].subtype,timest:result2.data[0].timestamp,temp:result2.data[0].sensordata.temperature,humid:result2.data[0].sensordata.humidity,bat:result2.data[0].sensordata.battery};
            //   this.dataTpr.push(payload);
            //  payload = {};
            //  console.log(this.dataTpr);
          });
        }
      });
      //      this.$API
      //  .get("indoorsensor")
      //    .then((result) => {
      // console.log(result)

      //    });
    },
    viewSensor(item) {
      //  console.log(item.mac)
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.type);
      this.$session.set("user", this.user);

      // console.log(this.network,item)
      this.$router.push({
        name: "AssetDashboardIndoor",
        params: {
          sensorname: this.name,
          macname: this.mac,
          user: this.user,
        },
      });
    },
    viewSensor2(item) {
      //  console.log(item.mac)
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.type);

      // console.log(this.network,item)
      this.$router.push({
        name: "SensorDashboardIndoor2",
        params: {
          sensorname: this.name,
          macname: this.mac,
        },
      });
    },
    getAssetC() {
      this.dataApr = [];
      this.$API.get("indoorasset").then((result) => {
        console.log(result.data);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          console.log(obj);
          console.log(moment(obj.timestamp).format("LTS"));
          console.log(moment(obj.lastdate).format("LTS"));
          console.log(moment().format("LTS"));
          console.log(
            moment
              .utc(moment(obj.lastdate).diff(moment(obj.firstdate)))
              .format("HH:mm:ss")
          );
          console.log(moment().format("LLL"));
          if (moment(obj.timestamp).diff(moment(obj.lastdate), "s") < 45) {
            this.state = "Active";
          } else {
            this.state = "Inactive";
          }
          console.log(this.state);
          let payloads = {
            name: obj.name,
            mac: obj.mac,
            type: obj.subtype,
            status: this.state,
            timestamp: moment(obj.timestamp).format("LTS"),
            firstdate: moment(obj.firstdate).format("LTS"),
            lastdate: moment(obj.lastdate).format("LTS"),
          };
          this.dataApr.push(payloads);
          payloads = {};
          console.log(this.dataApr);
        }
      });

      setTimeout(() => {
        this.assetc = this.dataApr;
      }, 300);
    },

    getUnia() {
      this.dataTprUnia = [];
      this.$API.get("indoor/getstock").then((result) => {
        console.log(result.data);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          console.log("wwwwwwrrrrrr", obj);
          // console.log(moment(obj.timestamp).format("LTS"));
          // console.log(moment(obj.lastdate).format("LTS"));
          // console.log(moment().format("LTS"));
          // console.log(
          //   moment
          //     .utc(moment(obj.lastdate).diff(moment(obj.firstdate)))
          //     .format("HH:mm:ss")
          // );
          // console.log(moment().format("LLL"));
          // if (moment(obj.timestamp).diff(moment(obj.lastdate), "s") < 45) {
          //   this.state = "Active";
          // } else {
          //   this.state = "Inactive";
          // }
          // console.log(this.state);
          if (obj.checkout_timestamp == null) {
            this.stout = "-";
          } else {
            this.stout = moment(obj.checkout_timestamp).format(
              "DD/MM/YYYY LTS"
            );
          }

          if (obj.detail == "") {
            this.details = "-";
          } else {
            this.details = obj.detail;
          }

          if (obj.quantity == null) {
            this.quant = "-";
          } else {
            this.quant = obj.quantity;
          }
          let payloads = {
            name: obj.name,
            mac: obj.mac,
            detail: this.details,
            quan: this.quant,
            status: obj.isStock,
            checkin: moment(obj.checkin_timestamp).format("DD/MM/YYYY LTS"),
            checkout: this.stout,
          };
          this.dataTprUnia.push(payloads);
          payloads = {};
          console.log(this.dataTprUnia);
        }
      });

      setTimeout(() => {
        this.assetc = this.dataApr;
      }, 300);
    },

    getTagPtta() {
      this.dataTprPtta = [];
      this.$API.get("indoortag").then((result) => {
        console.log(result);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          // console.log(obj);
          // console.log(moment(obj.timestamp).format('LTS'));
          // console.log(moment(obj.lastdate).format('LTS'));
          // console.log(moment().format('LTS'));
          // console.log(moment.utc(moment(obj.lastdate).diff(moment(obj.firstdate))).format("HH:mm:ss"));
          // console.log(moment().format('LLL'));
          // if(moment(obj.timestamp).format('LLL')==moment().format('LLL')){
          if (obj !== undefined) {
            if (moment(obj.timestamp).diff(moment(obj.lastdate), "m") < 4) {
              this.state = "Active";
            } else {
              this.state = "Inactive";
            }
            let payload = {
              name: obj.name,
              mac: obj.mac,
              type: obj.subtype,
              status: this.state,
              timestamp: moment(obj.timestamp).format("LTS"),
              firstdate: moment(obj.firstdate).format("L LTS"),
              lastdate: moment(obj.lastdate).format("L LTS"),
              working: moment
                .utc(moment(obj.lastdate).diff(moment(obj.firstdate)))
                .format("HH:mm:ss"),
            };
            this.dataTprPtta.push(payload);
            payload = {};
          }
        }
      });

      setTimeout(() => {
        this.ptta = this.dataTprPtta;
      }, 300);
    },

    getTagPttb() {
      this.dataTprPttb = [];
      this.$API.get("indoorasset").then((result) => {
        // console.log(result.data);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          // console.log(obj);
          // console.log(moment(obj.timestamp).format('LTS'));
          // console.log(moment(obj.lastdate).format('LTS'));
          // console.log(moment().format('LTS'));
          // console.log(moment.utc(moment(obj.lastdate).diff(moment(obj.firstdate))).format("HH:mm:ss"));
          // console.log(moment().format('LLL'));
          if (obj !== undefined) {
            if (moment(obj.timestamp).diff(moment(obj.lastdate), "s") < 45) {
              this.state = "Active";
            } else {
              this.state = "Inactive";
            }
            // console.log(this.state);
            let payloads = {
              name: obj.name,
              mac: obj.mac,
              type: obj.subtype,
              status: this.state,
              timestamp: moment(obj.timestamp).format("LTS"),
              firstdate: moment(obj.firstdate).format("L LTS"),
              lastdate: moment(obj.lastdate).format(" L LTS"),
            };
            this.dataTprPttb.push(payloads);
            payloads = {};
            // console.log(this.dataApr);
          }
        }
      });

      setTimeout(() => {
        this.pttb = this.dataTprPttb;
      }, 300);
    },
    getAsset() {
      // this.dataTpr2=[];
      // this.$API.get("indoorasset").then((result) => {
      //       // console.log(result.data);
      //       for(var i=0;i<=result.data.length;i++){
      //           let obj = result.data[i];
      //           console.log(obj);

      //           // console.log(moment(obj.timestamp).format('LTS'));
      //           // console.log(moment(obj.lastdate).format('LTS'));
      //           // console.log(moment().format('Do'));
      //           // console.log(moment(obj.firstdate).format('Do'));
      //           // console.log(moment.utc(moment(obj.lastdate).diff(moment(obj.firstdate))).format("HH:mm:ss"));
      //           // console.log(moment().format('LLL'));
      //           if(moment(obj.timestamp).diff(moment(obj.lastdate),'s') < 45){
      //           this.state="Active";

      //         }
      //         else{
      //           this.state="Inactive";

      //         }

      //         // console.log(this.state);
      //         let payload = {name:obj.name,mac:obj.mac,type:obj.subtype,status:this.state,firstdate:moment(obj.firstdate).format('LTS'),lastdate:moment(obj.lastdate).format('LTS'),working:moment.utc(moment(obj.lastdate).diff(moment(obj.firstdate))).format("HH.mm")};
      //         this.dataTpr.push(payload);
      //         payload = {};
      //         // console.log(this.dataTpr);

      //       }
      //     })

      setTimeout(() => {
        // this.asset=this.dataTpr2;
      }, 300);

      this.$API.get("indoorgateway/AC233FC0C2F9").then((result1) => {
        console.log(result1);
      });

      this.$API.get("indoorgateway/AC233FC0BA7A").then((result1) => {
        //  console.log(result1.data[0].sensorfound);
        for (var i = 0; i <= result1.data[0].sensorfound.length; i++) {
          let obj = result1.data[0].sensorfound[i];
          // console.log(obj.mac);
          this.$API.get("indoorsensor/" + obj.mac).then((result2) => {
            // console.log(result2.data);
            if (result2.data[0].subtype === "S4") {
              //  console.log("true S1");
              let payload = {
                name: result2.data[0].name,
                mac: result2.data[0].mac,
                type: result2.data[0].subtype,
                timest: result2.data[0].timestamp,
                uninstall: result2.data[0].sensordata.uninstalled,
                unlock: result2.data[0].sensordata.unlocked,
                bat: result2.data[0].sensordata.battery,
              };
              //  this.dataTpr2.push(payload);
              payload = {};
              //  console.log("Data",this.dataTpr2);
            }
            //          else{
            // //             this.state=false;
            //            }
            //           console.log(this.state);
            //  let payload = {name:result2.data[0].name,mac:result2.data[0].mac,type:result2.data[0].subtype,timest:result2.data[0].timestamp,temp:result2.data[0].sensordata.temperature,humid:result2.data[0].sensordata.humidity,bat:result2.data[0].sensordata.battery};
            //   this.dataTpr.push(payload);
            //  payload = {};
            //  console.log(this.dataTpr);
          });
        }
      });
    },
  },

  created() {
    // eslint-disable-next-line no-console
    // console.log(this.$session.get('token'),this.$session.get('username'))

    this.user = this.$session.get("username");
    this.admin = this.$session.get("admin");
    this.getTag();
    this.getTagPtta();
    this.getTagPttb();
    this.getAsset();
    this.getAssetC();
    this.getUnia();
    this.dataTpr = [];
    this.dataTpr2 = [];
    this.datatestS1 = [];
    this.datatestS4 = [];
    // var currentTime = Date.now()
    //     currentTime = moment(currentTime)

    //      result.data.forEach((element) => {
    //        var timeDiff = currentTime.diff(moment(element.lastdate),'m')
    //        if(timeDiff <= 2){
    //          this.asg++;
    //        }
    //        if(moment(element.lastdate).format('Do h:mA') == moment().format('Do h:mA')){
    //          console.log("Done");

    //        }
    //         console.log(timeDiff);
    //         console.log(this.asg);
    //      });
    this.$API.get("indoorsensor").then((result) => {
      console.log(result.data);
      this.ssf = result.data.length;
      this.$API.get("indoorgateway").then((result1) => {
        console.log(result1.data);
      });
      this.tag = this.datatestS1;
      this.asset = this.datatestS4;
      for (var i = 0; i < this.ssf; i++) {
        let obj = result.data[i];
        console.log(obj.lastdate);
        if (
          moment(obj.lastdate).format("Do hA") == moment().format("Do hA") &&
          obj.subtype == "S1"
        ) {
          // this.sdi++;
          // console.log(this.sdi);
          // this.gff++;
          let payload = {
            name: obj.name,
            mac: obj.mac,
            type: obj.subtype,
            timest: obj.timestamp,
            temp: obj.sensordata.temperature,
            humid: obj.sensordata.humidity,
            bat: obj.sensordata.battery,
          };
          this.dataTpr.push(payload);

          console.log(moment(obj.lastdate).format("Do hA"));
        }

        if (
          moment(obj.lastdate).format("Do hA") == moment().format("Do hA") &&
          obj.subtype == "S4"
        ) {
          // this.sdi++;
          // console.log(this.sdi);
          // this.gff++;
          let payload = {
            name: obj.name,
            mac: obj.mac,
            type: obj.subtype,
            timest: obj.timestamp,
            uninstall: obj.sensordata.uninstalled,
            unlock: obj.sensordata.unlocked,
            bat: obj.sensordata.battery,
          };
          this.dataTpr2.push(payload);

          // console.log(moment(obj.lastdate).format("Do hA"));
        }
      }
      // console.log(this.dataTpr);
    });
    this.$API.get("indoorsensor").then((result) => {
      console.log(result.data);

      var currentTime = Date.now();
      currentTime = moment(currentTime);

      result.data.forEach((element) => {
        var timeDiff = currentTime.diff(moment(element.lastdate), "m");
        console.log("Testtttttttttt", element);
        if (timeDiff <= 10) {
          console.log("Teslllllllllllllllll", element);
          if (element.subtype == "S1") {
            this.datatestS1.push({
              name: element.name,
              mac: element.mac,
              type: element.subtype,
              timest: element.timestamp,
              temp: element.sensordata.temperature,
              humid: element.sensordata.humidity,
              bat: element.sensordata.battery,
            });
          }
          if (element.subtype == "S4") {
            console.log("Tesssssssssssssssssss", element.mac);
            this.datatestS4.push({
              name: element.name,
              mac: element.mac,
              type: element.subtype,
              timest: element.timestamp,
              uninstall: element.sensordata.uninstalled,
              unlock: element.sensordata.unlocked,
              bat: element.sensordata.battery,
            });
          }
          this.sdi++;
        }
      });

      //
      for (var i = 0; i < this.ssf; i++) {
        let obj = result.data[i];
        if (moment(obj.lastdate).format("Do hA") == moment().format("Do hA")) {
          // this.sdi++;
          // console.log(this.sdi);
          // this.gff++;
          // console.log(moment(obj.lastdate).format('Do hA'));
        }
      }
    });

    this.$API.get("indoorgateway").then((result) => {
      // console.log(result.data[0].sensorfound)
      result.data[0].sensorfound.forEach((element) => {
        this.$API.get("indoorsensor").then((result1) => {
          result1.data.forEach((element2) => {
            if (element.mac == element2.mac && element.type == "S1") {
              // this.datatestS1.push({
              //   name: element2.name,
              //   mac: element2.mac,
              //   type: element2.subtype,
              //   timest: element2.timestamp,
              //   temp: element2.sensordata.temperature,
              //   humid: element2.sensordata.humidity,
              //   bat: element2.sensordata.battery,
              // });
            }
            if (element.mac == element2.mac && element.type == "S4") {
              this.datatestS4.push({
                name: element2.name,
                mac: element2.mac,
                type: element2.subtype,
                timest: element2.timestamp,
                uninstall: element2.sensordata.uninstalled,
                unlock: element2.sensordata.unlocked,
                bat: element2.sensordata.battery,
              });
            }
            // console.log(this.datatestS1);
          });
        });
        //  if(element.tagfound == null){
        //           state = "off"
        //         }
        //         else{state = "on"}
        // console.log(result.data)
        // this.gatewaylist.push({
        //   name: element.name,

        //   mac: element.mac,
        //   type: element.type,
        //   location: "Unavailable",
        //   status: state,
        //   active: true,
        //   signal: "100",
        //   networkID: element.nwid,
        // });
        //  console.log(element);
        // console.log(moment(element.sensorfound.timestamp).format("Do hA"));
        // this.nwGatewayID.push({ networkID: element.nwid });
      });
    });
    // setInterval(() => {
    //    this.getTag();
    // }, 60000)
  },
  mounted() {
    this.admin = this.$session.get("admin")
    switch (this.user || this.admin) {
      case "betagrodemo":
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
        });
        var elemtable = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.background = "#212121";
        });
        var elemtableheader =
          document.getElementsByClassName("vs-table--header");
        Array.prototype.filter.call(
          elemtableheader,
          function (testElementtableheader) {
            testElementtableheader.style.background = "#212121";
          }
        );
        var elemtableul = document.getElementsByClassName("vs-pagination--ul");
        Array.prototype.filter.call(elemtableul, function (testElementtableul) {
          testElementtableul.style.background = "none";
        });
        document.getElementById("myDiv").style.paddingBottom = "200px";
        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
};
</script>
